module.exports = __webpack_public_path__ + "static/media/klok.af0cd9e1.png";